import { render, staticRenderFns } from "./ClientGroup.vue?vue&type=template&id=666d82cc"
import script from "./ClientGroup.vue?vue&type=script&lang=js"
export * from "./ClientGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports